module.exports = "https://assets.pclncdn.com/web/next-landing/03c4f86f87/_next/static/images/atlanta-84fa7ae4bb1f7547470d71226164076b.webp";